import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_merchant_settings",
  ref: "merchantSettingsModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered w-600px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Automated Services", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-stack"
}
const _hoisted_11 = { class: "d-flex align-items-center me-5" }
const _hoisted_12 = { class: "me-5" }
const _hoisted_13 = {
  href: "#",
  class: "text-gray-800 fw-bolder text-hover-primary fs-6"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check form-switch form-check-custom form-check-solid" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input h-20px w-30px",
        type: "checkbox",
        value: "",
        id: "flexSwitchChecked",
        checked: "checked"
      })
    ])
  ])
], -1)
const _hoisted_15 = {
  key: 1,
  class: "separator separator-dashed my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (typeof product === 'string')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("a", _hoisted_13, _toDisplayString(product), 1)
                        ])
                      ]),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                (typeof product === 'string')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ], 512))
}